<template lang="pug">
  vue-good-table(
    ref="table"
    :columns="columns"
    :rows="clients"
    :sort-options=`{
      enabled: true,
      initialSortBy: {field: 'created_at', type: 'desc'}
    }`
    :pagination-options=`{
      enabled: true,
      perPage: 20,
      nextLabel: $t('pagination.next'),
      prevLabel: $t('pagination.back'),
      rowsPerPageLabel: $t('pagination.output'),
      allLabel: $t('pagination.all'),
      ofLabel: $t('pagination.of'),
    }`
    @on-row-click="onClickClientRow"
    @on-column-filter="onColumnFilter"
  )
    template(slot="table-row" slot-scope="props")
      span(v-if="props.column.field == 'options'")
        router-link.btn.btn-icon(
          :to="{ name: 'clients.client', params: { clientId: props.row.id }}"
        )
          font-awesome-icon.sidebar__menu-icon(icon="eye")
      span(v-else) {{props.formattedRow[props.column.field]}}
</template>

<script>
import { mapState } from 'vuex';

import { VueGoodTable } from 'vue-good-table';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faEye } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import config from '@/config';
import table from '@/mixins/table.mixin';

library.add(faEye);

export default {
  mixins: [table],

  data() {
    return {
      columns: [
        {
          label: 'Имя',
          field: 'name',
          filterOptions: {
            enabled: true,
            placeholder: 'Искать по имени'
          }
        },
        {
          label: 'Адрес',
          field: 'address',
          filterOptions: {
            enabled: true,
            placeholder: 'Искать по Городу'
          }
        },
        {
          label: 'Телефон',
          field: 'contact_phone'
        },
        {
          label: 'Кол-во заказов',
          field: 'orders_qty',
          type: 'number',
          thClass: 'vgt-table__cell--min-width',
          filterOptions: {
            enabled: true,
            placeholder: 'Искать по кол-ву заказов'
          }
        },
        {
          label: 'Дата регистрации',
          field: 'created_at',
          type: 'date',
          thClass: 'vgt-table__cell--min-width',
          dateInputFormat: config.dateTimeInputFormat,
          dateOutputFormat: config.dateOutputFormat,
          filterOptions: {
            enabled: true,
            placeholder: 'Дата регистрации',
            filterFn: this.dateRangeFilter
          }
        },
        {
          label: '',
          field: 'options',
          thClass: 'vgt-table__cell--min-width',
          sortable: false
        }
      ]
    };
  },

  computed: {
    ...mapState({
      firmId: state => state.user.profile.id,
      clients: state => state.clients.clients
    })
  },

  methods: {
    onClickClientRow(params) {
      this.$router.push({
        name: 'clients.client',
        params: { clientId: params.row.id }
      });
    }
  },

  components: {
    VueGoodTable,
    FontAwesomeIcon
  }
};
</script>
